import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1),
    backgroundPosition: 'bottom, left top',
    backgroundRepeat: 'repeat-x, repeat',
    backgroundSize: 'contain, cover',
    minHeight: 'calc(100vh - 106px)',
  },
  containers: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1),
    backgroundPosition: 'bottom, left top',
    backgroundRepeat: 'repeat-x, repeat',
    backgroundSize: 'contain, cover',
  },
  formContainer: {
    margin: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    width: '500px',
    '@media (max-width: 768px)': {
      width: '80%',
    },
  },
  formContainers: {
    margin: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 768px)': {
      width: '80%',
    },
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '10vh',
    margin: '0 100px',
    backgroundColor: 'transparent',
  },
  footer: {
    margin: '60px 0 30px 0',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '26px',
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
    '@media (max-width: 768px)': {
      position: 'relative',
      bottom: 0,
      right: 0,
      transform: 'none',
      margin: '60px 0 30px',
    },
  },
  alertmessage: {
    display: 'flex',
    borderRadius: '4px',
    margin: '0 auto',
    width: '500px',
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F44336',
  },
  alertbox: {
    display: 'flex',
    padding: '8px 18px',
  },
  alertIcon: {
    marginRight: '10px',
    color: '#F44336',
  },
  alertTitle: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600,
    color: '#621b16',
  },
}));
